{
  "title": "Şəxsi profil",
  "info": "Şəxsi məlumatlar",
  "idCopy": "ID-mi kopyalayın",
  "copied": "ID-niz kopyalandı",
  "copyFailed": "ID-ni kopyalamaq alınmadı",
  "name": "Ad",
  "surname": "Soyad",
  "birth": "Doğum tarixi",
  "gender": "Cins",
  "chooseGender": "Cinsi seçin",
  "male": "Kişi",
  "female": "Qadın",
  "save": "Yadda saxla",
  "saved": "Məlumatlar yadda saxlanıldı",
  "missing": "Zəhmət olmasa bütün şəxsi məlumatları doldurun.",
  "failed": "Məlumatları saxlamaq alınmadı.",
  "alreadySaved": "Şəxsi məlumatlar təsdiqlənib və kilidlənib.",
  "confirmTitle": "Hərəkəti təsdiqləyin",
  "confirmText": "Təsdiq etməklə şəxsi məlumatlarınızın düzgün və aktual olduğunu bildirirsiniz. Təsdiqdən sonra onları yalnız administratorun köməyi ilə dəyişmək mümkündür.",
  "verify": "Təsdiqlə",
  "back": "Qaytar",
  "contacts": "Əlaqə məlumatları",
  "linked": "Qoşulub",
  "notLinked": "Qoşulmayıb",
  "unverified": "Təsdiqlənməyib",
  "manage": "İdarə et",
  "telegram": "Telegram",
  "unavailable": "Mövcud deyil",
  "phone": "Telefon nömrəsi",
  "email": "E-poçt",
  "change": "Məlumatların dəyişdirilməsi",
  "pending": "Dəyişiklik sorğunuz yoxlanılır.",
  "requestTitle": "Məlumatların dəyişdirilməsi",
  "changeHelp": "Məlumatların dəyişdirilməsi administrator təsdiqi tələb edir.",
  "reason": "Dəyişiklik səbəbi",
  "submit": "Sorğu göndər",
  "noChanges": "Dəyişdiriləcək məlumat yoxdur.",
  "changeFailed": "Sorğu göndərilmədi.",
  "changeSent": "Sorğunuz administratora göndərildi.",
  "support": "Operatorla əlaqə",
  "age": "Doğum tarixini düzgün daxil edin.",
  "loggingOut": "Çıxış edilir...",
  "logout": "Hesabdan çıxış"
}
